export default "__VITE_ASSET__DiJcbA7n__"